import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import { authReducer } from "./authReducer";
import { userReducer } from "./userReducer";
import { combineReducers } from "redux";
import { accountReducer } from "./accountReducer";
import { statementReducer } from "./statementReducer";


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  accounts: accountReducer,
  statement: statementReducer
});
export default persistReducer(persistConfig, rootReducer);